export const isLoadInIFrame = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}